/**
 * Centralized configuration for Bean Wars
 *
 * Environment variables are loaded from Vite (VITE_ prefix for client-side).
 * Defaults are provided so the app works even without env vars.
 */

const DEFAULT_GOOGLE_SCRIPT_URL = 'https://script.google.com/macros/s/AKfycbzNKHWWTSStyNdB3kRf5z9I-GFR5ITbHdt63lEBvzsGTYzngACg_tQ9YdZmYVexRgtq/exec';

const DEFAULT_BLACKBIRD_CAFE_URL = 'https://myblackbirdcafe.com/';

/**
 * Google Apps Script URL for both reads and writes
 */
export const GOOGLE_SCRIPT_URL = import.meta.env.VITE_GOOGLE_SCRIPT_URL || DEFAULT_GOOGLE_SCRIPT_URL;

export const GOOGLE_SCRIPT_READ_URL = GOOGLE_SCRIPT_URL;

/**
 * API key for score writes (sent with POST requests to Apps Script)
 */
export const BEANWARS_API_KEY = import.meta.env.VITE_BEANWARS_API_KEY || '';

/**
 * Blackbird Cafe website URL
 */
export const BLACKBIRD_CAFE_URL = import.meta.env.VITE_BLACKBIRD_CAFE_URL || DEFAULT_BLACKBIRD_CAFE_URL;

export function validateConfig() {
  const warnings = [];

  if (!GOOGLE_SCRIPT_URL) {
    warnings.push('GOOGLE_SCRIPT_URL is not configured');
  }

  if (!BEANWARS_API_KEY) {
    warnings.push('BEANWARS_API_KEY is not configured — score submissions will fail');
  }

  if (warnings.length > 0) {
    console.warn('[Bean Wars Config]', warnings.join(', '));
  }

  return warnings.length === 0;
}
